import React from 'react'
import CopyRow from '../components/rows/CopyRow'
import FramedImage from '../components/rows/FramedImage'
import FramedVideoLoop from '../components/rows/FramedVideoLoop'
import FullwidthImage from '../components/rows/FullwidthImage'
import FullwidthVideo from '../components/rows/FullwidthVideo'
import SlideShow from '../components/rows/SlideShow'
import ImagesThirds from '../components/rows/ImagesThirds'
import StatsBlocks from '../components/rows/StatsBlocks'
import VideoLoop23 from '../components/rows/VideoLoop23'
import VideoLoop13 from '../components/rows/VideoLoop13'
import VideoLoop23Text from '../components/rows/VideoLoop23Text'
import VideoLoop23VideoLoop13 from '../components/rows/VideoLoop23VideoLoop13'
import FullwidthVideoLoop from '../components/rows/FullwidthVideoLoop'
import ImageText from '../components/rows/ImageText'
import ImagesThreeUp from '../components/rows/ImagesThreeUp'
import ImagesThirdsSpace from '../components/rows/ImagesThirdsSpace'
import FullwidthGif from '../components/rows/FullwidthGif'
import FramedVideo from '../components/rows/FramedVideo'
import VideoText from '../components/rows/VideoText'
import Image2Videoloop1 from '../components/rows/Image2Videoloop1'
import VideoPlayer23 from '../components/rows/VideoPlayer23'
import VideoPlayer3up from '../components/rows/VideoPlayer3up'

const PresentationRows = ({rows}) => {

    // helper function to get file extension
    const getExtension = (filename) => {
        return filename.split('.').pop();
    }

    return (
        
    
     rows.map((row, index)=> {

        //get everything after last _ in field name so we can use it for work and inspire
         const rowFullName = row.fieldGroupName
         const rowTypeIndex = rowFullName.lastIndexOf('_')
         const rowType = rowFullName.substr(rowTypeIndex+1)

         switch (rowType) {

            // copy row
            case 'CopyRow':
                const copyProps = {
                    copy: row.copy
                }
                return(
                    <CopyRow key={index} {...copyProps} />   
                )
        
          

            //framed image
            case 'FramedImage':
                const framedImageProps = {
                    backgroundColor: row.backgroundColor,
                    altText: row.image.altText ? row.image.altText: '',
                    localFile: row.image.localFile
                }
                return (
                    <FramedImage key={index} {...framedImageProps} />
                )
       

            //framed video loop
            case 'FramedVideoLoop':
                const framedVideoLoopProps = {
                    backgroundColor: row.backgroundColor,
                    src: row.video,
                    description: row.videoDescription
                }
                return (
                    <FramedVideoLoop key={index} {...framedVideoLoopProps} />
                )
          
            

            //full width image
            case 'FullwidthImage':
                const fullwidthImageProps = {
                    altText: row.image.altText ? row.image.altText : '',
                    localFile: row.image.localFile
                }
                return (
                    <FullwidthImage key={index} {...fullwidthImageProps} />
                )
          
            
            //full width video
            case 'FullwidthVideo':
                const fullwidthVideoProps = {
                    videoURL: row.videoUrl,
                    poster: row.poster.localFile.publicURL,
                    altText: row.poster.altText ? row.poster.altText : '' 
                }
                return (
                    <FullwidthVideo key={index} {...fullwidthVideoProps} />
                )
          

            //video player 23
            case 'VideoPlayer23':
                const videoPlayer23Props = {
                    videoURL: row.video,
                    poster: row.poster.localFile.publicURL,
                    altText: row.poster.altText ? row.poster.altText : '',
                    reversed: row.reversed 
                }
                return (
                    <VideoPlayer23 key={index} {...videoPlayer23Props} />
                )
           

            // video player 3up
            case 'VideoPlayer3up':
                const videoPlayer3upProps = {
                    videoURL1: row.videourl1,
                    poster1: row.poster1.localFile.publicURL,
                    altText1: row.poster1.altText ? row.poster1.altText : '',
                    videoURL2: row.videourl2,
                    poster2: row.poster2.localFile.publicURL,
                    altText2: row.poster2.altText ? row.poster2.altText : '',
                    videoURL3: row.videourl3,
                    poster3: row.poster3.localFile.publicURL,
                    altText3: row.poster3.altText ? row.poster3.altText : ''
                }
                return (
                    <VideoPlayer3up key={index} {...videoPlayer3upProps} />
                )
            

            //slideshow
            case 'Slideshow' :
                const slideshowProps = {
                    slides: row.slideshowV2,
                    slidesToShow: row.slidesToShow ? row.slidesToShow : 1,
                }
                return (
                    <SlideShow key={index} {...slideshowProps} />
                )
           

            // 2/3 1/3 Images
            case 'Images2313' :
                const img2313_localFile2Ext = row.imageLeft ? getExtension(row.imageLeft.localFile.publicURL) : false;
                const img2313_localFile1Ext = row.imageRight ? getExtension(row.imageRight.localFile.publicURL) : false;
                const imagesThirdsProps = {
                    dir: 'rtl',
                    localFile2: row.imageLeft ? row.imageLeft.localFile : false,
                    localFile2Ext: img2313_localFile2Ext,
                    localFile1: row.imageRight ? row.imageRight.localFile : false,
                    localFile1Ext: img2313_localFile1Ext,
                    altText2: row.imageLeft ? row.imageLeft.altText : false,
                    altText1: row.imageRight ? row.imageRight.altText : false
                }
                return (
                    <ImagesThirds key={index} {...imagesThirdsProps} />
                )
            

            // 1/3 2/3 Images
            case 'Images1323' :
                const img1323_localFile2Ext = row.imageLeft ? getExtension(row.imageLeft.localFile.publicURL) : false;
                const img1323_localFile1Ext = row.imageRight ? getExtension(row.imageRight.localFile.publicURL) : false;
                const imagesThirds2Props = {
                    dir: 'ltr',
                    localFile1: row.imageLeft ? row.imageLeft.localFile : false,
                    localFile1Ext: img1323_localFile1Ext,
                    localFile2: row.imageRight ? row.imageRight.localFile : false,
                    localFile2Ext: img1323_localFile2Ext,
                    altText1: row.imageLeft ? row.imageLeft.altText : '',
                    altText2: row.imageRight ? row.imageRight.altText : ''
                }
                return (
                    <ImagesThirds key={index} {...imagesThirds2Props} />
                )
            

            // 2/3 space 1/3 images
            case 'Images23Space13' :
                const localFile2Ext = row.imageLeft ? getExtension(row.imageLeft.localFile.publicURL) : false;
                const localFile1Ext = row.imageRight ? getExtension(row.imageRight.localFile.publicURL) : false;

                const images23Space13Props = {
                    dir: 'rtl',
                    localFile2: row.imageLeft ? row.imageLeft.localFile : false,
                    localFile2Ext: localFile2Ext,
                    localFile1: row.imageRight ? row.imageRight.localFile : false,
                    localFile1Ext: localFile1Ext,
                    altText2: row.imageLeft ? row.imageLeft.altText : false,
                    altText1: row.imageRight ? row.imageRight.altText : false
                }
                return (
                    <ImagesThirdsSpace key={index} {...images23Space13Props} />
                )
            

            // 1/3 space 2/3 images
            case 'Images13Space23' :
                const img12space23_localFile2Ext = row.imageLeft ? getExtension(row.imageLeft.localFile.publicURL) : false;
                const img12space23_localFile1Ext = row.imageRight ? getExtension(row.imageRight.localFile.publicURL) : false;
               
                const images13Space23Props = {
                    dir: 'ltr',
                    localFile1: row.imageLeft ? row.imageLeft.localFile : false,
                    localFile1Ext: img12space23_localFile1Ext,
                    localFile2: row.imageRight ? row.imageRight.localFile : false,
                    localFile2Ext: img12space23_localFile2Ext,
                    altText1: row.imageLeft ? row.imageLeft.altText : '',
                    altText2: row.imageRight ? row.imageRight.altText : ''
                }
                return (
                    <ImagesThirdsSpace key={index} {...images13Space23Props} />
                )
         
            
            // Stats Blocks
            case 'StatsBlocks' :
                const statsBlocksProps = {
                    stats: row.statBlock
                }
                return (
                    <StatsBlocks key={index} {...statsBlocksProps} />
                )
            

            // 2/3 Video Loop 1/3 Image
            case '23VideoLoop' :
                const twoThirdsVideoLoopProps = {
                    src: row.video,
                    description: row.descriptiveText,
                    localFile: row.image13 ? row.image13.localFile : false,
                    altText: row.image13 ? row.image13.altText : false,
                    reverse: false
                }
                return (
                    <VideoLoop23 key={index} {...twoThirdsVideoLoopProps} />
                )
        
            //  1/3 Image 2/3 Video Loop
            case '13Image23VideoLoop' :
                const oneThirdImagetwoThirdsVideoLoopProps = {
                    src: row.video,
                    description: row.descriptiveText,
                    localFile: row.image13 ? row.image13.localFile : false,
                    altText: row.image13 ? row.image13.altText : false,
                    reverse: true
                }
                return (
                    <VideoLoop23 key={index} {...oneThirdImagetwoThirdsVideoLoopProps} />
                )
        
            //  1/3 Video Loop 2/3 Image
            case 'VideoLoop13Image23' :
                const oneThirdVideoLooptwoThirdsImageProps = {
                    src: row.video,
                    description: row.descriptiveText,
                    localFile: row.image23 ? row.image23.localFile : false,
                    altText: row.image23 ? row.image23.altText : false,
                    reverse: true
                }
                return (
                    <VideoLoop13 key={index} {...oneThirdVideoLooptwoThirdsImageProps} />
                )
        
            //  2/3 Image 1/3 Video Loop
            case 'Image23VideoLoop13' :
                const twoThirdsImageoneThirdVideoLoopProps = {
                    src: row.video,
                    description: row.descriptiveText,
                    localFile: row.image23 ? row.image23.localFile : false,
                    altText: row.image23 ? row.image23.altText : false,
                    reverse: false
                }
                return (
                    <VideoLoop13 key={index} {...twoThirdsImageoneThirdVideoLoopProps} />
                )
         
             // 2/3 Video Loop 1/3 Text
            case '23VideoLoopText' :
                const twoThirdsVideoLoopTextProps = {
                    src: row.video,
                    description: row.descriptiveText,
                    text: row.text,
                }
                return (
                    <VideoLoop23Text key={index} {...twoThirdsVideoLoopTextProps} />
                )
           
            // 1/3 Video Loop 2/3 Video Loop
            case '13VideoLoop23VideoLoop' :
                const oneThirdsVideoLoopTwoThirdsVideoLoopProps = {
                    vidSrc13: row.video13,
                    vidDesc13: row.video13Description,
                    vidSrc23: row.video23,
                    vidDesc23: row.video23Description,
                    reverse: true
                }
                return (
                    <VideoLoop23VideoLoop13 key={index} {...oneThirdsVideoLoopTwoThirdsVideoLoopProps} />
                )
          
            // 2/3 Video Loop 1/3 Video Loop
            case '23VideoLoop13VideoLoop' :
                const twoThirdsVideoLoopOneThirdsVideoLoopProps = {
                    vidSrc13: row.video13,
                    vidDesc13: row.video13Description,
                    vidSrc23: row.video23,
                    vidDesc23: row.video23Description,
                    reverse: false
                }
                return (
                    <VideoLoop23VideoLoop13 key={index} {...twoThirdsVideoLoopOneThirdsVideoLoopProps} />
                )
            

            // Fullwidth Video Loop
            case 'FullwidthVideoLoop' :
                const fullwidthVideoLoopProps = {
                    src: row.video,
                    description: row.descriptiveText
                }
                return (
                    <FullwidthVideoLoop key={index} {...fullwidthVideoLoopProps} />
                )
           

            // Image text
            case 'ImageText' :
                const imageTextProps = {
                   localFile: row.image.localFile,
                   altText: row.altText,
                   copy: row.text
                }
                return (
                    <ImageText key={index} {...imageTextProps} />
                )
           

            // Video text
            case 'VideoText' :
                const videoTextProps = {
                    videoURL: row.video,
                    altText: row.descriptiveText,
                    poster: row.posterImage ? row.posterImage.localFile.publicURL : false,
                    copy: row.text,
                    halfAndHalf: row.halfAndHalfLayout,
                    loop: row.loopVideo
                }
                return (
                    <VideoText key={index} {...videoTextProps} />
                )
           

            // Image 3 Up
            case 'Images3Up' :
                const images3UpProps = {
                    localFile1: row.image1 ? row.image1.localFile : false,
                    localFile1URL: row.image1 ? row.image1.localFile.publicURL : false,
                    localFile1ext: row.image1 ? getExtension(row.image1.localFile.publicURL) : false,
                    vid1: row.vid1 ? row.vid1 : false,
                    vid1AltText: row.vid1AltText ? row.vid1AltText : '',
                    localFile2: row.image2 ? row.image2.localFile : false,
                    localFile2URL: row.image1 ? row.image2.localFile.publicURL : false,
                    localFile2ext: row.image1 ? getExtension(row.image2.localFile.publicURL) : false,
                    vid2: row.vid2 ? row.vid2 : false,
                    vid2AltText: row.vid2AltText ? row.vid2AltText : '',
                    localFile3: row.image3 ? row.image3.localFile : false,
                    localFile3URL: row.image3 ? row.image3.localFile.publicURL : false,
                    localFile3ext: row.image3 ? getExtension(row.image3.localFile.publicURL) : false,
                    vid3: row.vid3 ? row.vid3 : false,
                    vid3AltText: row.vid3AltText ? row.vid3AltText : '',
                    altText1: row.image1 ? row.image1.altText : '',
                    altText2: row.image2 ? row.image2.altText : '',
                    altText3: row.image3 ? row.image3.altText : ''
                }
                return (
                    <ImagesThreeUp key={index} {...images3UpProps} />
                )
            

            // Fullwidth GIF
            case 'FullwidthGif' :
                const fullwidthGifProps = {
                    src: row.image.localFile.publicURL,
                    altText: row.image.altText
                }
                return (
                    <FullwidthGif key={index} {...fullwidthGifProps} />
                )
           

            // Framed Video
            case 'FramedVideo' :
                const framedVideoProps = {
                    videoURL: row.video,
                    poster: row.posterImage.localFile.publicURL,
                    altText: row.posterImage.altText,
                    vertical: row.vertical
                }
                return (
                    <FramedVideo key={index} {...framedVideoProps} />
                )
            

            case 'Image2Videoloop1':
                const image2Videoloop1Props = {
                    space: row.space,
                    reverse: row.reverse,
                    videoURL: row.video,
                    descriptiveText: row.descriptiveText,
                    localFile: row.image2 ? row.image2.localFile : false,
                    altText: row.image2 ? row.image2.altText : false,
                }
                return (
                    <Image2Videoloop1 key={index} {...image2Videoloop1Props} />
                )
          
              
            default:
                console.log('donut have yr ' + rowType + ' component yet')
                return


         }
     })
    )
}

export default PresentationRows
